import script from "./KytChainLoading.vue?vue&type=script&setup=true&lang=ts"
export * from "./KytChainLoading.vue?vue&type=script&setup=true&lang=ts"

import "./KytChainLoading.vue?vue&type=style&index=0&id=4d2adf10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d2adf10"]])

export default __exports__